import { palette } from "lib/miolo";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import flatten from "lodash/flatten";
import { Element, Node } from "slate";

interface IFinancialHighlightsSummaryProps {
  lastFinancialHighlights: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["lastFinancialHighlights"]>;
}

export default function FinancialHighlightsSummary({ lastFinancialHighlights }: IFinancialHighlightsSummaryProps) {
  const topSentences = serializeToPlainTextSentences(lastFinancialHighlights.highlights).slice(0, 3);

  return (
    <div css={{ padding: 12, backgroundColor: palette.catskillWhite, borderRadius: 4 }}>
      <div
        css={{
          display: "-webkit-box",
          overflow: "hidden",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        <p
          css={{
            margin: 0,
            color: palette.blueBayoux,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.33,
          }}
        >
          {topSentences.join(" ").slice(0, 160)}
        </p>
      </div>
    </div>
  );
}

function serializeToPlainTextSentences(nodes: Node[]): string[] {
  return flatten(
    nodes.map((node) => {
      // serialize list items with \n. So instead of it serializing as "A B C D" it will be:
      // A
      // B
      // C
      // D
      // TODO: https://github.com/ianstormtaylor/slate/issues/4915
      // @ts-ignore
      if (Element.isElement(node) && (node.type === "numbered-list" || node.type === "bulleted-list")) {
        return serializeToPlainTextSentences(node.children as Node[]);
      }

      return Node.string(node);
    }),
  );
}
